import React from 'react';
import styles from './ChargingPageCustom_Orion.module.css'
import DashboardMain_Orion from '../DashboardMain_Orion/DashboardMain_Orion';
import * as $ from 'jquery';
import { useCallback, useContext, useEffect, useState } from "react";
import { INIT_FILTER_STATE } from '../../../constants/driveglobalfilterinitalstates_orion';
import { API_URL_MAIN } from '../../../constants/driveglobalfilterinitalstates_orion';
import useHttp from '../../../hook/use-http'
import AppContext from '../../../store/AppContext';
import ChargingFirstPageKpis_Orion from './ChargingFirstPage_Orion/ChargingFirstPageKpis_Orion';
import HighlightsKpis_Orion from './ChargingFirstPage_Orion/HighlightsKpis_Orion';
import ChargingInterruptionDuration_Orion from './ChargingFirstPage_Orion/ChargingInterruptionDuration_Orion';

import { useSelector } from 'react-redux';
import { selectLoggedInUser } from "../../../redux/userSlice"
import GunConnectVehicles_Orion from './ChargingFirstPage_Orion/GunConnectVehicles_Orion';
import GunConnectCycles_Orion from './ChargingFirstPage_Orion/GunConnectCycles_Orion';
import SocAtChargeStartVehicles_Orion from './ChargingFirstPage_Orion/SocAtChargeStartVehicles_Orion';
import SocAtChargeStartCycles_Orion from './ChargingFirstPage_Orion/SocAtChargeStartCycles_Orion';
import RateOfChargeCycles_Orion from './ChargingFirstPage_Orion/RateOfChargeCycles_Orion';
import RateOfChargeVehicles_Orion from './ChargingFirstPage_Orion/RateOfChargeVehicles_Orion';
import AverageChargeCurrentCycles_Orion from './ChargingFirstPage_Orion/AverageChargeCurrentCycles_Orion';
import AverageChargeCurrentVehicles_Orion from './ChargingFirstPage_Orion/AverageChargeCurrentVehicles_Orion';
import Charged_Per_SOC_Cycles_Orion from './ChargingFirstPage_Orion/Charged_Per_SOC_Cycles_Orion';
import Charged_Per_SOC_Vehicles_Orion from './ChargingFirstPage_Orion/Charged_Per_SOC_Vehicles_Orion';
import Charged_Per_KWH_Cycles_Orion from './ChargingFirstPage_Orion/Charged_Per_KWH_Cycles_Orion';
import Charged_Per_KWH_Vehicles_Orion from './ChargingFirstPage_Orion/Charged_Per_KWH_Vehicles_Orion';
import MaxCellTemp_cycles_Orion from './ChargingFirstPage_Orion/MaxCellTemp_cycles_Orion';
import MaxCellTemp_vehicles_Orion from './ChargingFirstPage_Orion/MaxCellTemp_vehicles_Orion';
import MaxCellVoltage_cycles_Orion from './ChargingFirstPage_Orion/MaxCellVoltage_cycles_Orion';
import MaxCellVoltage_vehicles_Orion from './ChargingFirstPage_Orion/MaxCellVoltage_vehicles_Orion';
import Charging_Filters_Orion from './Charging_Filters_Orion';
import CandlestickChart_Orion from './ChargingFirstPage_Orion/CandlestickChart_Orion';
import { decodeToken } from 'react-jwt';
import CoolantInVehicles_Orion from './ChargingFirstPage_Orion/CoolantInVehicles_Orion';
import CoolantInCycles_Orion from './ChargingFirstPage_Orion/CoolantInCycles_Orion';

export default function ChargingPage_Orion() {
  const tokenNew = JSON.parse(sessionStorage.user);
  let decodedToken = decodeToken(tokenNew.token);
  const city_name = decodedToken.city_name;
  const city_name_arr = city_name.split(",");
  const depo_name = decodedToken.depo_name;
  const depo_name_arr = depo_name.split(",");
  let sampleObj = (city_name != "") ? { ...INIT_FILTER_STATE, CITY: city_name_arr, DEPO: depo_name_arr } : INIT_FILTER_STATE

  const [gloablfilter, setGloablfilter] = useState(sampleObj)
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const app_ctx = useContext(AppContext);

  const log_data = (data) => {
  }

  useEffect(() => {
    window.$("#button-1_Orion").checked = false
    fetchData({
      url: API_URL_MAIN + "auth/logging", body: {
        page_name: "Charginganalysis_orion"
      }
    }, log_data)
  }, []);

  const [toSeeChartType, setToSeeChartType] = useState('d-block');
  const [toSeeToggle, setToSeeToggle] = useState('d-block');
  useEffect(() => {
    if (gloablfilter.VIN_NUM.length === 1) {
      setChartType_option("candle")
      setToSeeChartType('d-block')
      setToSeeToggle('d-none');
      setTypeSOC("Fast");
      setTypeMaxTempBattery("Fast")
      setPerCycle("Fast")
      setType('Fast')
      setTypeFCD("Fast")
      setMaxCellTemp("Fast")
      setMaxCellVoltage("Fast")
      SetChartName("Charging Pattern")
    } else {
      setToSeeChartType('d-none')
      setToSeeToggle('d-block')
    }
  }, [gloablfilter]);

  const [fromTableToFilter_vin, setFromTableToFilter_vin] = useState(0);
  const filterSubmited = useCallback((data) => {
    if (data.VIN_NUM.length === 1) {
      setFromTableToFilter_vin(data.VIN_NUM[0])
    }
    setGloablfilter(data);
  }, []);

  const singleVinSelected = (vin) => {
    let vin_num = vin.split(",");
    setFromTableToFilter_vin(vin_num[0])
    setGloablfilter((prevdata) => { return { ...prevdata, VIN_NUM: vin_num, pageSelected: 2 } });
  }

  const onreset = (data) => {
    setGloablfilter(data);
  }

  // code for ROC 
  const [chartSelected, setChartSelected] = useState('bar')
  const [type, setType] = useState('Slow')
  const [ROC_SF, setROC_SF] = useState('Slow')
  const changeTB = (selectedOption) => {
    setChartSelected(selectedOption)
  }
  const handleChangeROC = (e) => {
    if (e.target.checked === false) {
      setType('Slow')
      setROC_SF('Slow')
    } else {
      setType('Fast')
      setROC_SF('Fast')
    }
  }
  // code for ROC

  // code for BMS
  const [perCycle_Option, setPerCycle_Option] = useState('soc')
  const [soc_kwh_tiltle, setSoc_kwh_tiltle] = useState('SOC Charged per Cycle')
  const changePerCycle = (selectedOption) => {
    setSoc_kwh_tiltle(selectedOption.target.selectedOptions[0].innerHTML + " Charged per Cycle")
    setPerCycle_Option(selectedOption.target.value)
  }

  // code for BMS 

  // code for max cell temp
  const [chartnameSOC1, SetChartNameSOC1] = useState("Pack A - Max Cell Temp");
  const [maxCellTemp_Option, setMaxCellTemp_Option] = useState('A_Max_Cell_Temp')
  const changeMaxCellTemp = (event) => {
    SetChartNameSOC1(event.target.selectedOptions[0].innerHTML + " - Max Cell Temp")
    // SetChartNameSOC1("Pack " + event.target.selectedOptions[0].innerHTML + " - Max Cell Temp")
    setMaxCellTemp_Option(event.target.value)
  }
  const [maxCellTemp, setMaxCellTemp] = useState('Slow')
  const [chartNameMaxCellTemp, setChartNameMaxCellTemp] = useState("AAAAAAAAA");
  const handleMaxCellTemp = (e) => {
    if (e.target.checked === false) {
      setMaxCellTemp("Slow")
      setChartNameMaxCellTemp("SOC at which charging starts")
    } else {
      setMaxCellTemp("Fast")
      setChartNameMaxCellTemp("SOC at which charging starts")
    }
  }
  // code for max cell temp

  // code for max cell voltage
  const [chartnameSOC2, SetChartNameSOC2] = useState("Pack A - Min Cell Volt");
  const [maxCellVoltage_Option, setMaxCellVoltage_Option] = useState('A_Min_Cell_Volt')
  const [maxCellVoltage_OptionMM, setMaxCellVoltage_OptionMM] = useState('Min')
  // ADD THESE 2 STATES
  const [coolantin_Option, setCoolantin_Option] = useState("A_Coolant_Temp_Out");
  const [coolantin_OptionMM, setCoolantin_OptionMM] = useState("Out");
  const changeMaxCellVoltageMM = (selectedOption) => {
    SetChartNameSOC2("Pack " + maxCellVoltageO.replace(/_/g, '') + " - " + selectedOption + " Cell Volt")
    setMaxCellVoltage_OptionMM(selectedOption)
    setMaxCellVoltage_Option(maxCellVoltageO + selectedOption + '_Cell_Volt')
  }
  const [maxCellVoltageO, setMaxCellVoltageO] = useState('A_')
  const changeMaxCellVoltage = (selectedOption) => {
    SetChartNameSOC2("Pack " + selectedOption.replace(/_/g, '') + " - " + maxCellVoltage_OptionMM + " Cell Volt")
    setMaxCellVoltageO(selectedOption)
    setMaxCellVoltage_Option(selectedOption + maxCellVoltage_OptionMM + '_Cell_Volt')
  }
  const [coolantChartName, setCoolantChartName] = useState("Pack A - Coolant");

  // State for selected coolant pack
  const [coolantPack, setCoolantPack] = useState("");
  const [selectedPack, setSelectedPack] = useState("A");



  // State for combined coolant option (used for API or chart)

  // 
  const changeCoolantPackOption = (selectedPack) => {
    const option = selectedPack + 'Coolant_Temp_' + coolantin_OptionMM;

    setCoolantin_Option(option);
    setCoolantPack(selectedPack);

    const newName = `Pack ${selectedPack.replace(/_/g, ' ')} - Coolant`;


    setCoolantChartName(newName);

  };


  const [maxCellVoltage, setMaxCellVoltage] = useState('Slow')
  const [chartNameMaxCellVoltage, setChartNameMaxCellVoltage] = useState("AAAAAAAAA");
  const handleMaxCellVoltage = (e) => {
    if (e.target.checked === false) {
      setMaxCellVoltage("Slow")
      setChartNameMaxCellVoltage("SOC at which charging starts")
    } else {
      setMaxCellVoltage("Fast")
      setChartNameMaxCellVoltage("SOC at which charging starts")
    }
  }
  // code for max cell voltage

  // code for FCD
  const [typeFCD, setTypeFCD] = useState('Slow')
  const [check, SetCheck] = useState("gunDurationInMin");
  const [chartname, SetChartName] = useState("Gun Connect Duration");
  const [API_FCD, SetAPI_FCD] = useState("gun_connect_duration_vehicles");
  const handleFCD = (e) => {
    if (e.target.checked === false) {
      setTypeFCD("Slow")
      SetCheck("gunDurationInMin")
      SetChartName("Gun Connect Duration");
      SetAPI_FCD("gun_connect_duration_vehicles");
    } else {
      setTypeFCD("Fast")
      SetCheck("FC10_80TimeInMin")
      SetChartName("Gun Connect Duration")
      SetAPI_FCD("gun_connect_duration_cycles")
    }
  }
  // code for FCD

  // code for max temp
  const [typeMaxTemp, setTypeMaxTemp] = useState('Slow')
  const [chartnameMT, SetChartNameMT] = useState("Max coolant temp(oC) - Slow chrg");
  const handleMaxTemp = (e) => {
    if (e.target.checked === false) {
      setTypeMaxTemp("Slow")
      SetChartNameMT("Max coolant temp(oC) - Slow chrg")
    } else {
      setTypeMaxTemp("Fast")
      SetChartNameMT("Max coolant temp(oC) - Fast chrg")
    }
  }
  // code for max temp

  // code for SOC
  const [typeSOC, setTypeSOC] = useState('Slow')
  const [chartnameSOC, SetChartNameSOC] = useState("Avg Charging Current");
  const handleSOC = (e) => {
    if (e.target.checked === false) {
      setTypeSOC("Slow")
      SetChartNameSOC("Avg Charging Current")
    } else {
      setTypeSOC("Fast")
      SetChartNameSOC("Avg Charging Current")
    }
  }
  // code for SOC

  // code for max Battery temp
  const [typeMaxTempBattery, setTypeMaxTempBattery] = useState('Slow')
  const [chartnameMaxTempBattery, SetChartNameMaxTempBattery] = useState("SOC at which charging starts");
  const handleMaxTempBattery = (e) => {
    if (e.target.checked === false) {
      setTypeMaxTempBattery("Slow")
      SetChartNameMaxTempBattery("SOC at which charging starts")
    } else {
      setTypeMaxTempBattery("Fast")
      SetChartNameMaxTempBattery("SOC at which charging starts")
    }
  }
  // code for max Battery temp

  // code for soc charged per cycles
  const [perCycle, setPerCycle] = useState('Slow')
  const [chartNamePerCycle, setChartNamePerCycle] = useState("AAAAAAAAA");
  const [coolantToggleState, setCoolantToggleState] = useState(false);

  const handleChangeSocPerCycle = (e) => {
    if (e.target.checked === false) {
      setPerCycle("Slow")
      setChartNamePerCycle("SOC at which charging starts")
    } else {
      setPerCycle("Fast")
      setChartNamePerCycle("SOC at which charging starts")
    }
  }
  // code for soc charged per cycles
  const [chartType_option, setChartType_option] = useState("bar")
  const changeChartType = (selectedOption) => {
    setChartType_option(selectedOption)
    if (selectedOption === "bar") {
      SetChartName("Charging Session Duration")
    } else {
      SetChartName("Charging Pattern")
    }
  }




  const handleCoolantToggle = (value) => {
    if (value === "In") {
      setCoolantin_Option(`${selectedPack}_Coolant_Temp_In`);
      setCoolantin_OptionMM("In");
    } else {
      setCoolantin_Option(`${selectedPack}_Coolant_Temp_Out`);
      setCoolantin_OptionMM("Out");
    }
  };


  const changeCoolantPack = (value) => {
    const mm = coolantin_OptionMM; // In / Out

    if (mm === "In") {
      coolantin_Option(`${value}Coolant_Temp_In`);
    } else {
      coolantin_Option(`${value}Coolant_Temp_Out`);
    }
  };


  const loggedInUser = useSelector(selectLoggedInUser);
  return (
    <>
      <DashboardMain_Orion>
        <Charging_Filters_Orion onsubmit={filterSubmited} gloablfilter={gloablfilter} onreset={onreset} fromTableToFilter_vin={fromTableToFilter_vin} />
        <div className="container-fluid drpg1" >
          <ChargingFirstPageKpis_Orion gloablfilter={gloablfilter} />
          <section className="highlights">
            <div className="row">
              <HighlightsKpis_Orion gloablfilter={gloablfilter} />
            </div>
          </section>

          <section className="highlights">
            <div className="row mb-3 equal-cols">
              {/* chart moved side to table */}
              {/* <div className="col-lg-3 col-md-6 col-sm-12 pr-0"> */}
              {/* <div className="chargingChartboxNew_Bus">
                  <div className="v-title chargingTitleChart_Bus">
                    <div className="row">
                      <div className="col-lg-9 col-md-9 col-sm-9 col-9">
                        <div className="p-2"><b>{chartnameSOC}</b></div>
                      </div>
                      <div className={`col-lg-3 col-md-3 col-sm-3 col-3 ${toSeeToggle}`}>
                        <div className="toggleBtn_Bus pt-0">
                          <div className="toggle-button-cover">
                            <div className="button-cover">
                              <div className="buttonbtn r" id="button-1_Bus">
                                <input type="checkbox" className="checkbox" onChange={handleSOC} />
                                <div className="knobs" />
                                <div className="layer" />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="chargingChartHGT_Bus">
                    {
                      typeSOC === "Slow" ?
                        <AverageChargeCurrentVehicles_Orion gloablfilter={gloablfilter} apiend={"average_vehicles"} type={typeSOC} chartnameFCD="" />
                        :
                        <AverageChargeCurrentCycles_Orion gloablfilter={gloablfilter} apiend="average_cycles" type={typeSOC} />
                    }
                  </div>
                </div>
              </div> */}
              {/* chart moved side to table */}

              <ChargingInterruptionDuration_Orion gloablfilter={gloablfilter} singleVinSelected={singleVinSelected} />
            </div>
          </section>


          {/* } */}
          <section className="graphs">
            <div className="row mt-2 mb-3 equal-cols">
              {/* chart moved side to table */}

              <div className="col-lg-4 col-md-4 col-sm-12 pr-0">
                <div className={`${styles.chargingChartbox_Orion} ${styles.wd_4_charts_Orion}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Orion}`}>
                    <div className="row">
                      <div className="col-lg-9 col-md-9 col-sm-9 col-9">
                        <div className="p-2"><b>{chartnameMaxTempBattery}</b></div>
                      </div>
                      <div className={`col-lg-3 col-md-3 col-sm-3 col-3 ${toSeeToggle}`}>
                        <div className={`${styles.toggleBtn_Orion} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Orion">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleMaxTempBattery} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Orion}`}>
                    {
                      typeMaxTempBattery === "Slow" ?
                        <SocAtChargeStartVehicles_Orion gloablfilter={gloablfilter} apiend={"soc_at_charge_start_vehicles"} type={typeMaxTempBattery} chartnameFCD="" />
                        :
                        <SocAtChargeStartCycles_Orion gloablfilter={gloablfilter} apiend="soc_at_charge_start_cycles" type={typeMaxTempBattery} />
                    }
                  </div>
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 pr-0">
                <div className={`${styles.chargingChartbox_Orion} ${styles.wd_4_charts_Orion}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Orion}`}>
                    <div className="row">
                      <div className="col-lg-9 col-md-9 col-sm-9 col-9">
                        <div className="p-2"><b>{chartnameSOC}</b></div>
                      </div>
                      <div className={`col-lg-3 col-md-3 col-sm-3 col-3 ${toSeeToggle}`}>
                        <div className={`${styles.toggleBtn_Orion} pt-0`}> 
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              {/* added for design */}
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Orion">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleChangeSocPerCycle} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Orion}`}>
                    {
                      typeSOC === "Slow" ?
                        <AverageChargeCurrentVehicles_Orion gloablfilter={gloablfilter} apiend={"average_vehicles"} type={typeSOC} chartnameFCD="" />
                        :
                        <AverageChargeCurrentCycles_Orion gloablfilter={gloablfilter} apiend="average_cycles" type={typeSOC} />
                    }
                  </div>
                </div>
              </div>
              {/* chart moved side to table */}

              <div className="col-lg-4 col-md-4 col-sm-12 ">
                <div className={`${styles.chargingChartbox_Orion} ${styles.wd_4_charts_Orion}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Orion}`}>
                    <div className="row ">
                      <div className="col-lg-6 col-sm-6">
                        <div className="p-2 text-start"><b>{soc_kwh_tiltle}</b></div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3">
                        <select className="form-select form-select-sm mt-1" aria-label=".form-select-sm example" onChange={(event) => changePerCycle(event)}
                          value={perCycle_Option}>
                          <option value="kwh">kWh</option>
                          <option value="soc">Soc</option>
                        </select>
                      </div>
                      <div className={`col-lg-3 col-sm-3 text-end ${toSeeToggle}`}>
                        <div className={`${styles.toggleBtn_Orion}`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Orion">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleChangeROC} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                              {/* added for design */}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Orion}`}>
                    {
                      (perCycle_Option === "soc" && perCycle === "Slow") &&
                      <Charged_Per_SOC_Vehicles_Orion gloablfilter={gloablfilter} apiend={"soc_charged_per_vehicles"} type={perCycle} chartnameFCD={soc_kwh_tiltle} />
                    }
                    {
                      (perCycle_Option === "soc" && perCycle !== "Slow") &&
                      <Charged_Per_SOC_Cycles_Orion gloablfilter={gloablfilter} apiend="soc_charged_per_cycles" type={perCycle} chartnameFCD={soc_kwh_tiltle} />
                    }
                    {
                      (perCycle_Option === "kwh" && perCycle === "Slow") &&
                      <Charged_Per_KWH_Vehicles_Orion gloablfilter={gloablfilter} apiend={"kwh_charged_per_vehicles"} type={perCycle} chartnameFCD={soc_kwh_tiltle} />
                    }
                    {
                      (perCycle_Option === "kwh" && perCycle !== "Slow") &&
                      <Charged_Per_KWH_Cycles_Orion gloablfilter={gloablfilter} apiend="kwh_charged_per_cycles" type={perCycle} chartnameFCD={soc_kwh_tiltle} />
                    }

                  </div>
                </div>
              </div>



            </div>
            {/* 3rd */}
            <div className="row equal-cols">
              <div className="col-lg-4 col-md-4 col-sm-12 pr-0">
                <div className={`${styles.chargingChartbox_Orion} ${styles.wd_4_charts_Orion}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Orion}`}>
                    <div className="row">
                      <div className="col-lg-5 col-md-6 col-sm-5 col-5">
                        <div className="p-2"><b>Rate of charge</b></div>
                      </div>
                      <div className="col-lg-7 col-md-6 col-sm-7 col-7">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                            <div className="dropdownSelectBtnCharging_Orion">
                            </div>
                          </div>
                          <div className={`col-lg-6 col-md-6 col-sm-6 col-6 ${toSeeToggle}`}>
                            <div className={`${styles.toggleBtn_Orion} pt-0`}>
                              <div className={`${styles["toggle-button-cover"]}`}>
                                <div className={`${styles["button-cover"]}`}>
                                  <div className={`${styles.buttonbtn.r}`} id="button-1_Orion">
                                    <input type="checkbox" className={`${styles.checkbox}`} onChange={handleChangeROC} />
                                    <div className={`${styles.knobs}`} />
                                    <div className={`${styles.layer}`} />
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className={`${styles.chargingChartHGT_Orion}`}>
                    {
                      type === "Slow" ?
                        <RateOfChargeVehicles_Orion gloablfilter={gloablfilter} apiend="roc_vehicles" type={type} chartnameFCD="" />
                        :
                        <RateOfChargeCycles_Orion gloablfilter={gloablfilter} apiend="roc_cycles" type={type} />
                    }
                  </div>
                </div>
              </div>

               <div className="col-lg-4 col-md-6 col-sm-12 pr-0">
                <div className={`${styles.chargingChartbox_Orion} ${styles.wd_4_charts_Orion}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Orion}`}>
                    <div className="row">
                      <div className={toSeeChartType === "d-block" ? "col-lg-6 col-md-6 col-sm-6 col-6" : "col-lg-9 col-md-9 col-sm-9 col-9"}>
                        <div className="p-2 text-start"><b>{chartname}</b></div>
                      </div>
                      <div className={`col-lg-3 col-md-3 col-sm-3 col-3 ${toSeeChartType}`}>
                        <select className="form-select form-select-sm mt-1" aria-label=".form-select-sm example" onChange={(event) => changeChartType(event.target.value)}
                          value={chartType_option}>
                          <option value="bar">Charging Session Duration</option>
                          <option value="candle">Charging Pattern</option>
                        </select>
                      </div>
                      <div className={`col-lg-3 col-md-3 col-sm-3 col-3 ${toSeeToggle}`}>
                        <div className={`${styles.toggleBtn_Orion} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Orion">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleFCD} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Orion}`}>
                    {
                      typeFCD === "Slow" ?
                        <GunConnectVehicles_Orion gloablfilter={gloablfilter} apiend="gun_connect_duration_vehicles" type={typeFCD} chartnameFCD={chartname} />
                        :
                        (chartType_option === "bar") ?
                          <GunConnectCycles_Orion gloablfilter={gloablfilter} apiend="gun_connect_duration_cycles" type={typeFCD} chartType_option={chartType_option} chartnameFCD={chartname} />
                          :
                          <CandlestickChart_Orion gloablfilter={gloablfilter} apiend="gun_connect_duration_cycles_candle" type={typeFCD} chartType_option={chartType_option} chartnameFCD={chartname} />
                    }
                  </div>
                </div>
              </div>

              <div className="col-lg-4 col-md-6 col-sm-12 ">
                <div className={`${styles.chargingChartbox_Orion} ${styles.wd_4_charts_Orion}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Orion}`}>
                    <div className="row">
                      <div className="col-lg-6 col-md-6 col-sm-6 col-6">
                        <div className="p-2"><b>{chartnameSOC1}</b></div>
                      </div>
                      <div className="col-lg-3 col-md-4 col-sm-4 col-4">
                        <select className="form-select form-select-sm mt-1" aria-label=".form-select-sm example" onChange={(event) => changeMaxCellTemp(event)} value={maxCellTemp_Option} >
                          <option value="A_Max_Cell_Temp">Pack A</option>
                          <option value="B_Max_Cell_Temp">Pack B</option>
                          {/* <option value="C_Max_Cell_Temp">Pack C</option>
                          <option value="D_Max_Cell_Temp">Pack D</option> */}
                        </select>
                      </div>
                      <div className={`col-lg-2 col-md-2 col-sm-2 col-2 ${toSeeToggle}`} style={{ paddingLeft: "0px" }}>
                        <div className={`${styles.toggleBtn_Orion} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Orion">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleMaxCellTemp} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Orion}`}>
                    {
                      maxCellTemp === "Slow" ?
                        <MaxCellTemp_vehicles_Orion gloablfilter={gloablfilter} apiend={"max_cell_temp_vehicles"} type={maxCellTemp} chartnameFCD={chartnameSOC1} maxCellTemp_Option={maxCellTemp_Option} />
                        :
                        <MaxCellTemp_cycles_Orion gloablfilter={gloablfilter} apiend="max_cell_temp_cycles" type={maxCellTemp} maxCellTemp_Option={maxCellTemp_Option} chartnameFCD={chartnameSOC1} />
                    }
                  </div>
                </div>
              </div>

            </div>
            {/* last */}
            <div className="row equal-cols mt-3">
              <div className="col-lg-4 col-md-6 col-sm-12 mb-3 pr-0 mb-3">
                <div className={`${styles.chargingChartbox_Orion} ${styles.wd_4_charts_Orion}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Orion}`}>
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                        <div className="pt-2 pb-2" style={{ fontSize: "11px", paddingLeft: "3px" }}><b>{chartnameSOC2}</b></div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3 pr-1 pl-1 pt-1">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeMaxCellVoltageMM(event.target.value)} value={maxCellVoltage_OptionMM}>
                          <option value="Min">Min</option>
                          <option value="Max">Max</option>
                        </select>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3 pr-1 pl-1 pt-1">
                        <select className="form-select form-select-sm" aria-label=".form-select-sm example" onChange={(event) => changeMaxCellVoltage(event.target.value)} value={maxCellVoltageO}>
                          <option value="A_">Pack A</option>
                          <option value="B_">Pack B</option>
                          {/* <option value="C_">Pack C</option>
                          <option value="D_">Pack D</option> */}
                        </select>
                      </div>
                      <div className={`col-lg-2 col-md-2 col-sm-2 col-2 pl-0 ${toSeeToggle}`} style={{ paddingLeft: "0px" }}>
                        <div className={`${styles.toggleBtn_Orion} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Orion">
                                <input type="checkbox" className={`${styles.checkbox}`} onChange={handleMaxCellVoltage} />
                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Orion}`}>
                    {
                      maxCellVoltage === "Slow" ?
                        <MaxCellVoltage_vehicles_Orion gloablfilter={gloablfilter} apiend={"max_cell_voltage_vehicles"} type={maxCellVoltage} chartnameFCD={chartnameSOC2} maxCellVoltage_Option={maxCellVoltage_Option} maxCellVoltage_OptionMM={maxCellVoltage_OptionMM} />
                        :
                        <MaxCellVoltage_cycles_Orion gloablfilter={gloablfilter} apiend="max_cell_voltage_cycles" type={maxCellVoltage} maxCellVoltage_Option={maxCellVoltage_Option} chartnameFCD={chartnameSOC2} />
                    }
                  </div>
                </div>

              </div>
              <div className="col-lg-4 col-md-6 col-sm-12 mb-3 mb-3">
                <div className={`${styles.chargingChartbox_Orion} ${styles.wd_4_charts_Orion}`}>
                  <div className={`v-title ${styles.chargingTitleChart_Orion}`}>
                    <div className="row">
                      <div className="col-lg-4 col-md-4 col-sm-4 col-4">
                        <div className="pt-2 pb-2" style={{ fontSize: "11px", paddingLeft: "3px" }}><b>{coolantChartName}</b></div>
                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3 pr-1 pl-1 pt-1">
                        <select
                          className="form-select form-select-sm"
                          value={coolantin_OptionMM}
                          onChange={(event) => {
                            const value = event.target.value;
                            setCoolantin_OptionMM(value); // update state
                            handleCoolantToggle(value);    // call your function with the new value
                          }}
                        >
                          <option value="In">In</option>
                          <option value="Out">Out</option>
                        </select>

                      </div>
                      <div className="col-lg-3 col-md-3 col-sm-3 col-3 pr-1 pl-1 pt-1">
                        <select
                          className="form-select form-select-sm"
                          value={coolantPack}
                          onChange={(event) => changeCoolantPackOption(event.target.value)}
                        >
                          <option value="A_">Pack A</option>
                          <option value="B_">Pack B</option>
                          {/* <option value="C_">Pack C</option>
                          <option value="D_">Pack D</option> */}
                        </select>
                      </div>
                      <div className={`col-lg-2 col-md-2 col-sm-2 col-2 pl-0 ${toSeeToggle}`} style={{ paddingLeft: "0px" }}>
                        <div className={`${styles.toggleBtn_Orion} pt-0`}>
                          <div className={`${styles["toggle-button-cover"]}`}>
                            <div className={`${styles["button-cover"]}`}>
                              <div className={`${styles.buttonbtn.r}`} id="button-1_Orion">
                                <input
                                  type="checkbox"
                                  className={`${styles.checkbox}`}
                                  onChange={(e) => setCoolantToggleState(e.target.checked)}
                                />

                                <div className={`${styles.knobs}`} />
                                <div className={`${styles.layer}`} />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`${styles.chargingChartHGT_Orion}`}>

                    {/* ✨ Toggle decides which component to show */}
                    {coolantToggleState ? (
                      <CoolantInCycles_Orion
                        apiend="coolant_in_cycles"
                        gloablfilter={gloablfilter}
                        type={type}
                        finalCoolantKey={selectedPack + '_Coolant_Temp_' + coolantin_OptionMM}
                        coolantin_Option={coolantin_Option}
                        coolantin_OptionMM={coolantin_OptionMM}
                      />
                    ) : (

                      <CoolantInVehicles_Orion
                        apiend="coolant_in_vehicles"
                        gloablfilter={gloablfilter}
                        type={type}
                        coolantin_Option={coolantin_Option}
                        coolantin_OptionMM={coolantin_OptionMM}
                        finalCoolantKey={selectedPack + '_Coolant_Temp_' + coolantin_OptionMM}
                        chartnameFCD={selectedPack + '_Coolant_Temp_' + coolantin_OptionMM}

                      />
                    )}

                  </div>
                </div>
              </div>

            </div>


          </section>

        </div>
      </DashboardMain_Orion>
    </>
  )
}